import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { FaSearch } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
import PuertoSelect from "../components/PuertoSelect";
import PaisSelect from "../components/PaisSelect";
import GraficoUbigeo from "../components/GraficoUbigeo";

const EstadisticaCliente = () => {
  const [selectedPais, setSelectedPais] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const [ruc, setRuc] = useState(searchParams.get("ruc") || "");
  const [anio, setAnio] = useState(searchParams.get("anio") || "2025");
  const [nombre, setNombre] = useState(searchParams.get("nombre") || "");
  const [tipo, setTipo] = useState("1");

  const [rucEmpresa, setRucEmpresa] = useState(searchParams.get("strRucEmpresa") || "");
  const [empresa, setEmpresa] = useState(searchParams.get("strEmpresa") || "Desconocido");
  const [usuario, setUsuario] = useState(searchParams.get("strUsuario") || "Guest");
  const [ip, setIp] = useState(searchParams.get("strIP") || "0.0.0.0");
  const [pcName, setPcName] = useState(searchParams.get("strPcName") || "Desconocido");

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [headers, setHeaders] = useState([]);
  const [selectedPuerto, setSelectedPuerto] = useState(""); // Puerto


  useEffect(() => {
    if (ruc) {
      fetchData();
    }
  }, []);

  const fetchNombreEmpresa = async () => {
    if (nombre && nombre !== "Nombre no encontrado") {
      return;
    }

    try {
      const response = await fetch(`https://api.apis.net.pe/v1/ruc?numero=${ruc}`);

      if (!response.ok) {
        throw new Error("Error en la respuesta de la API");
      }

      const jsonData = await response.json(); // Convertimos directamente a JSON

      // Extraer el nombre de la empresa si está disponible
      const nombreEmpresa = jsonData?.nombre ?? "Nombre no encontrado";

      setNombre(nombreEmpresa);
    } catch (error) {
      console.error("Error al obtener el nombre de la empresa:", error);
      setNombre("Nombre no encontrado");
    }
  };




  const fetchData = async () => {
    setLoading(true);
    setError(null);
    await fetchNombreEmpresa();

    Swal.fire({
      title: "Cargando datos...",
      text: "Por favor, espera un momento",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    let intTipo = tipo;

    let apiUrl = `https://msoftperu.azurewebsites.net/home/GetEstadisticaCliente?strRuc=${ruc}&intAnio=${anio}&intTipo=${intTipo}&strPuerto=${selectedPuerto}&strRucEmpresa=${rucEmpresa}&strEmpresa=${empresa}&strUsuario=${usuario}&strIP=${ip}&strPcName=${pcName}&strPais=${(selectedPais)}`;


    try {
      const response = await axios.get(apiUrl);
      setData(response.data);
      if (response.data.length > 0) {
        setHeaders(Object.keys(response.data[0]));
      }
      Swal.close();
    } catch (err) {
      setError("Error al obtener datos");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudieron cargar los datos",
      });
    }
    setLoading(false);
  };

  return (
    <div className="p-8 max-w-5xl mx-auto bg-white shadow-md rounded-lg">
      <h2 className="text-2xl font-bold text-center mb-4">Estadística del Cliente</h2>

      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-4">
          <label className="font-semibold">RUC:</label>
          <input
            type="text"
            className="border border-gray-400 rounded-lg p-2 text-lg"
            value={ruc}
            onChange={(e) => setRuc(e.target.value)}
          />
          <label className="font-semibold">Año:</label>
          <select
            className="border border-gray-400 rounded-lg p-2 text-lg"
            value={anio}
            onChange={(e) => setAnio(e.target.value)}
          >
            {[2025, 2024, 2023, 2022, 2021, 2020].map((year) => (
              <option key={year} value={year}>{year}</option>
            ))}
          </select>
          <PuertoSelect selectedPuerto={selectedPuerto} setSelectedPuerto={setSelectedPuerto} strRuc={ruc} />


          <label className="font-semibold mr-2">Tipo:</label>
          <select
            className="border border-gray-400 rounded-lg p-2 text-lg"
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
          >
            <option value="1">Forwarder</option>
            <option value="2">Agente</option>
            <option value="3">Shipper</option>
          </select>



          <button
            data-tooltip-id="Buscar-tooltip"
            data-tooltip-content="Buscar"
            className="bg-blue-600 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded-lg"
            onClick={() => {
              fetchData();
            }}
          >
            <FaSearch />

          </button>
          <Tooltip id="Buscar-tooltip" />
        </div>

      </div>
      <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-4 mb-6">
        <div className="flex items-center space-x-2">
          <PaisSelect selectedPais={selectedPais} setSelectedPais={setSelectedPais} strRuc={ruc} intTipo="2" />
        </div>
        <GraficoUbigeo />
      </div>
      


      {loading && <p className="text-center">Cargando...</p>}
      {error && <p className="text-center text-red-600">{error}</p>}

      {!loading && !error && data.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 shadow-md text-sm">
            <thead className="bg-blue-500 text-white">
              <tr>
                {headers.map((header, idx) => (
                  <th key={idx} className="border p-2">
                    {header === "DES_FFW" ? "Nombre" : header === "RUC_FFW" ? "RUC" : header}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {data.map((item, idx) => (
                <tr key={idx} className="hover:bg-gray-100 text-center">
                  {headers.map((header, hIdx) => {
                    const isClickable = header === "DES_FFW" || header === "RUC_FFW";
                    return (
                      <td
                        key={hIdx}
                        className={`border p-2 ${isClickable ? "cursor-pointer text-blue-600 underline" : ""
                          }`}

                      >
                        {item[header]}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="text-center my-4">
        <button
          className="bg-gray-600 hover:bg-gray-800 text-white font-bold py-2 px-4 rounded-lg mr-4"
          onClick={() => navigate(-1)}
        >
          Regresar
        </button>
      </div>
    </div>
  );
};

export default EstadisticaCliente;